import http from "../http";

// export all dashboard services 
export const fmDashboardService = {
    getAllInvoiceListing,
    getCashFlowListing,
    getAccountPayableListing,
    exportAccountPayableCsvService,
}

// get all-invoices listing
function getAllInvoiceListing({payload}: any) {
    return http.get(`${process.env.REACT_APP_BASE_URL}/finance/invoices-listing/?page=${payload?.page}&perPage=${payload?.perPage}`);
}

// get cash flow listing (filters, sort, pagination - same pattern as projects listing)
function getCashFlowListing({ payload }: any) {
    return http.post(
        `${process.env.REACT_APP_BASE_URL}/finance/cash-flow-listing/?page=${payload?.page ?? 1}&perPage=${payload?.perPage ?? 10}`,
        { filters: payload?.filters }
    );
}

// get account payable listing (same endpoint as cash flow for now)
function getAccountPayableListing({ payload }: any) {
    return http.post(
        `${process.env.REACT_APP_BASE_URL}/finance/sub-expense-payments/?page=${payload?.page ?? 1}&perPage=${payload?.perPage ?? 10}`,
        { filters: payload?.filters }
    );
}

/** CSV export for account payable; uses the same filters shape as getAccountPayableListing. */
function exportAccountPayableCsvService({ payload }: any) {
    return http.post(
        `${process.env.REACT_APP_BASE_URL}/finance/v2/sub-expense-payments/export-csv`,
        { filters: payload?.filters },
        { responseType: "blob" }
    );
}